import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  allowedTemplates: PropTypes.arrayOf(PropTypes.string),
  allowedBlocks: PropTypes.arrayOf(PropTypes.string),
});
